(function(){
  function reveal(root){
    var els=(root||document).querySelectorAll('.zj-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)||window.Shopify&&Shopify.designMode){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(e){io.observe(e)});
  }
  function lightbox(root){
    (root||document).querySelectorAll('[data-zj-gallery]').forEach(function(g){
      if(g.dataset.zjReady) return; g.dataset.zjReady=1;
      var items=[].slice.call(g.querySelectorAll('[data-zj-full]'));
      var lb=document.getElementById('zj-lightbox');
      if(!lb){lb=document.createElement('div');lb.id='zj-lightbox';lb.className='zj-lightbox';lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');lb.setAttribute('aria-label','Photo viewer');
        lb.innerHTML='<button class="zj-lb-close" aria-label="Close">&times;</button><button class="zj-lb-prev" aria-label="Previous photo">&#8249;</button><img alt=""><button class="zj-lb-next" aria-label="Next photo">&#8250;</button>';document.body.appendChild(lb);}
      var img=lb.querySelector('img'),list=[],i=0;
      function show(n){i=(n+list.length)%list.length;img.src=list[i].dataset.zjFull;img.alt=list[i].dataset.zjAlt||'';}
      function close(){lb.removeAttribute('open');document.documentElement.style.overflow='';}
      items.forEach(function(b,n){b.addEventListener('click',function(){list=items;show(n);lb.setAttribute('open','');document.documentElement.style.overflow='hidden';lb.querySelector('.zj-lb-close').focus();});});
      if(!lb.dataset.bound){lb.dataset.bound=1;
        lb.querySelector('.zj-lb-close').onclick=close;
        lb.querySelector('.zj-lb-prev').onclick=function(){show(i-1)};
        lb.querySelector('.zj-lb-next').onclick=function(){show(i+1)};
        lb.addEventListener('click',function(e){if(e.target===lb)close();});
        document.addEventListener('keydown',function(e){if(!lb.hasAttribute('open'))return;if(e.key==='Escape')close();if(e.key==='ArrowRight')show(i+1);if(e.key==='ArrowLeft')show(i-1);});
      }
    });
  }
  function a11y(){
    // Product photo slider app: make its arrow controls usable with a keyboard and screen reader
    document.querySelectorAll('.pmslider-arrows_area-left,.pmslider-arrows_area-right').forEach(function(el){
      if(el.getAttribute('role'))return;
      el.setAttribute('role','button');el.setAttribute('tabindex','0');
      el.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();el.click();}});
    });
  }
  function init(r){reveal(r);lightbox(r);a11y();setTimeout(a11y,1500);}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',function(){init()});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
